import { useQuery } from '@/hooks/useQuery'
import Head from 'next/head'
import { ReactElement } from 'react'

import { Loading } from '@/components/Loading'
import { SignUpLayout } from '@/components/layout/web'
import { WebEula } from '@/components/web-eula'
import { useClientOnly } from '@/hooks/useClientOnly'
import { graphql } from 'gql.tada'

export default function PrivacyPolicyPage() {
  useClientOnly()

  const [{ data: latestContractsData, fetching }] = useQuery({
    query: PrivacyPolicyPage_Query,
    requestPolicy: 'cache-and-network',
  })
  const contract = latestContractsData?.latestContract
  return (
    <>
      <Head>
        <title>ロジックラボ | プライバシーポリシー</title>
      </Head>

      {contract && <WebEula contract={contract} />}

      {fetching && (
        <div className="pointer-events-none fixed inset-0 grid place-items-center">
          <Loading />
        </div>
      )}
    </>
  )
}

PrivacyPolicyPage.getLayout = (page: ReactElement) => (
  <SignUpLayout>{page}</SignUpLayout>
)

const PrivacyPolicyPage_Query = graphql(`
  query PrivacyPolicyPage_Query {
    latestContract(contractType: PRIVACY_POLICY) {
      id
      title
      content
    }
  }
`)
